import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Contact1 = styled.section`
  padding: 110px 0;
  position: relative;
  z-index: 10;
  background:
    radial-gradient(circle at 80% 20%, ${(props) => props.theme.text}1c 0%, transparent 45%),
    #050505;

  @media screen and (max-width: 768px) {
    padding: 80px 0;
  }
`;

export const MaxWidth = styled.div`
  max-width: 1140px;
  margin: 0 auto;
  padding: 0 50px;

  @media screen and (max-width: 768px) {
    padding: 0 22px;
  }
`;

export const Title = styled(motion.h2)`
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${(props) => props.theme.text};
  margin-bottom: 10px;
`;

export const Heading = styled(motion.h1)`
  text-align: center;
  font-size: 42px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 56px;
  font-family: 'Poppins', sans-serif;

  @media screen and (max-width: 768px) {
    font-size: 30px;
    margin-bottom: 40px;
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 40px;
  align-items: stretch;

  @media screen and (max-width: 920px) {
    flex-direction: column;
  }
`;

export const ColumnLeft = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ColumnRight = styled.div`
  flex: 1.2;
  min-width: 0;
`;

export const Text = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 12px;
`;

export const P = styled.p`
  font-size: 16px;
  line-height: 1.7;
  color: #9aa3b2;
  margin-bottom: 30px;
  max-width: 460px;
`;

export const Icons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const IconBox = styled.div`
  width: 46px;
  height: 46px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  color: ${(props) => props.theme.text};
  background: ${(props) => props.theme.text}1c;
  border: 1px solid ${(props) => props.theme.text}3a;
  font-size: 18px;
`;

export const Info = styled.div``;

export const Head = styled.div`
  font-size: 13px;
  color: #8b94a3;
  margin-bottom: 2px;
`;

export const SubTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #e9edf5;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 30px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
`;

export const FieldRow = styled.div`
  display: flex;
  gap: 16px;

  @media screen and (max-width: 520px) {
    flex-direction: column;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 7px;
`;

export const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #aab2c0;
`;

const fieldBase = `
  width: 100%;
  padding: 13px 15px;
  font-size: 15px;
  color: #fff;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 11px;
  outline: none;
  font-family: 'Poppins', sans-serif;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &::placeholder { color: #6b7280; }
`;

export const Input = styled.input`
  ${fieldBase}
  &:focus {
    border-color: ${(props) => props.theme.text};
    box-shadow: 0 0 0 3px ${(props) => props.theme.text}26;
  }
`;

export const TextArea = styled.textarea`
  ${fieldBase}
  resize: vertical;
  min-height: 130px;
  &:focus {
    border-color: ${(props) => props.theme.text};
    box-shadow: 0 0 0 3px ${(props) => props.theme.text}26;
  }
`;

export const Button = styled.button`
  margin-top: 6px;
  padding: 14px 28px;
  font-size: 16px;
  font-weight: 700;
  color: #050505;
  background: ${(props) => props.theme.text};
  border: none;
  border-radius: 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  box-shadow: 0 12px 30px -12px ${(props) => props.theme.text};

  &:hover:not(:disabled) {
    transform: translateY(-2px);
  }
  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;

export const Status = styled.div`
  font-size: 14px;
  font-weight: 600;
  padding: 12px 14px;
  border-radius: 11px;
  border: 1px solid;
  border-color: ${({ $ok }) =>
    $ok ? 'rgba(52,199,89,0.4)' : 'rgba(255,99,99,0.4)'};
  background: ${({ $ok }) =>
    $ok ? 'rgba(52,199,89,0.12)' : 'rgba(255,99,99,0.12)'};
  color: ${({ $ok }) => ($ok ? '#7ee2a0' : '#ff8f8f')};
`;

export const Spinner = styled.span`
  width: 16px;
  height: 16px;
  border: 2px solid rgba(5, 5, 5, 0.35);
  border-top-color: #050505;
  border-radius: 50%;
  display: inline-block;
  animation: spin 0.7s linear infinite;

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;
